export default __webpack_public_path__ + "static/media/DATAWEB 2.4e3714f6.svg";